import TermList from "../AdminTermList";

export default class AdminTermListDistributionReasonType extends TermList {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return "distribution_reason_type";
    }
}
